import axios from 'axios'
import { Message } from 'element-ui'

// create an axios instance
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API || '/', // url = base url + request url
    timeout: 15000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        // Add JWT token to request headers if available
        const token = localStorage.getItem('token')
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`
        }
        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    response => {
        const res = response.data

        // If response is direct data (not wrapped), return it
        if (!res.code && !res.message) {
            console.log('Response data:', res); // Debug log
            return res;
        }

        // if the custom code is not 20000 or 200, it is judged as an error.
        if (res.code && res.code !== 20000 && res.code !== 200) {
            // Only show error message for specific cases, not for empty data
            if (res.code !== 404 && res.code !== 204) {
                Message({
                    message: res.message || '错误',
                    type: 'error',
                    duration: 5 * 1000
                })
            }

            // 401: Token expired or invalid
            if (res.code === 401) {
                localStorage.removeItem('token')
                localStorage.removeItem('userInfo')
                window.location.href = '/login'
            }

            return Promise.reject(new Error(res.message || '错误'))
        } else {
            return res.data || res
        }
    },
    error => {
        console.log('err' + error) // for debug

        // Don't show toast for 404 errors (data empty or API not found)
        // Don't show toast for network errors (user will retry)
        const silentErrors = [404, 503, 502, 504]
        const status = error.response?.status

        if (status && silentErrors.includes(status)) {
            // Silently reject without showing toast
            return Promise.reject(error)
        }

        let message = error.message
        if (error.response) {
            if (error.response.status === 401) {
                message = '未授权，请重新登录'
                localStorage.removeItem('token')
                localStorage.removeItem('userInfo')
                window.location.href = '/login'
            } else if (error.response.status === 403) {
                message = '拒绝访问'
            } else if (error.response.status === 500) {
                message = '服务器端出错'
            }
        }

        // Only show message for non-silent errors
        Message({
            message: message,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)

export default service
